import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { useExtrasPageLinkWithFallback } from '../../extras/helpers/useExtrasPageLinkWithFallback';
import { ParkingPageId } from '../../../../domain/pages/ParkingPageId';
import { useUrlForPageId } from '../../../../../app/pages/ui/utils/useUrlForPageId';

interface IParentLink {
	parentTitle: string;
	parentUrl: string;
}

export function useDetailsPageParentLink(): IParentLink {
	const { t } = useTranslation();
	const extrasParentUrl = useUrlForPageId(ParkingPageId.NewBookingExtras);
	const extrasParentTitle = t('web_parking_details_back_button');
	const fallbackParentUrl = useUrlForPageId(
		ParkingPageId.NewBookingAvailability,
	);
	const fallbackParentTitle = t('web_parking_details_back_button_no_extras');

	const { url, title } = useExtrasPageLinkWithFallback({
		extrasTitle: extrasParentTitle,
		extrasUrl: extrasParentUrl,
		fallbackTitle: fallbackParentTitle,
		fallbackUrl: fallbackParentUrl,
	});

	return {
		parentUrl: url,
		parentTitle: title,
	};
}
